import { Row } from '@simplywallst/ui-core';
import DocumentHeader from '@/components/DocumentHeader';
import { Container, Heading, Copy } from './styled';
import Logo from '@assets/images/logo/warren-ice-cream.svg';
import GlobalStyle from '@/styled/styled.default';

const Maintenance = () => {
  return (
    <Row height="100vh" width="100vw">
      <GlobalStyle />
      <DocumentHeader title={'Down for maintenance'} />
      <Container
        justifyContent="center"
        alignItem="center"
        alignContent="center"
        displayFlex
        column
      >
        <Logo />
        <Heading>We are under scheduled maintenance</Heading>
        <Copy>
          We are working to restore the service as soon as possible and
          apologise for any inconvenience. Thank you for your patience.
        </Copy>
      </Container>
    </Row>
  );
};

export default Maintenance;
